module.exports = __webpack_public_path__ + "media/bootstrap-icons/shop-window-25ff3c12.svg";